import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CompaniesList from "./components/CompaniesList";
import CompaniesListMobile from "./components/CompaniesListMobile";
import CompanyDetail from "./components/CompanyDetail";
import "./App.css";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <Helmet>
        <title>SwitchSmartly - Find Your Next Job at High-Growth Companies</title>
        <meta name="description" content="Discover exciting career opportunities at high-growth companies. Explore detailed company insights, funding information, and market analysis to find your next dream job." />
        <meta name="keywords" content="startup jobs, careers, high-growth companies, job opportunities, tech careers, company insights, career growth" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://SwitchSmartly.com/" />
        <meta property="og:title" content="SwitchSmartly - Find Your Next Job at High-Growth Companies" />
        <meta property="og:description" content="Discover exciting career opportunities at high-growth companies. Explore detailed company insights to find your next dream job." />
        <meta property="og:image" content="https://SwitchSmartly.com/og-image.jpg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://SwitchSmartly.com/" />
        <meta property="twitter:title" content="SwitchSmartly - Find Your Next Job at High-Growth Companies" />
        <meta property="twitter:description" content="Discover exciting career opportunities at high-growth companies. Explore detailed company insights to find your next dream job." />
        <meta property="twitter:image" content="https://SwitchSmartly.com/og-image.jpg" />

        <meta name="google-adsense-account" content="ca-pub-6950549355554638"></meta>
        
        {/* Favicon */}
        <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
        <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/site.webmanifest" />
        
        {/* Additional SEO tags */}
        <meta name="author" content="SwitchSmartly" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="2 days" />
        <link rel="canonical" href="https://SwitchSmartly.com/" />

        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6950549355554638"
     crossorigin="anonymous"></script>
        <script>
          {`
            // Initialize header ad
            (adsbygoogle = window.adsbygoogle || []).push({});
            
            // Initialize other ads on page load
            window.addEventListener('load', function() {
              (adsbygoogle = window.adsbygoogle || []).push({});
            });
          `}
        </script>
      </Helmet>
      
      <div className="app-container">
        {/* Navigation Bar */}
        <nav className="app-nav">
          <div className="app-branding">
            <Link to="/" className="app-logo-link">
              <img src="/logo.png" alt="SwitchSmartly Logo" className="app-logo" />
            </Link>
          </div>
        </nav>

        {/* Main Content */}
        <main className="app-main">
          <Routes>
            <Route path="/" element={isMobile ? <CompaniesListMobile /> : <CompaniesList />} />
            <Route path="/company/:id" element={<CompanyDetail />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
